// eslint-disable-next-line
export const UPDATE_ORGANIZATION_DETAILS = 'UPDATE_ORGANIZATION_DETAILS';
